











import { Component, Vue, Prop } from 'vue-property-decorator';
import ConversationData from '@/ts/ConversationData';
import PersonData from '@/ts/PersonData';

@Component
export default class HorizontalParticipantIcons extends Vue {
    @Prop() public conversation!: ConversationData;

    constructor() {
        super();
    }

    get dataLoaded(): boolean {
        // TODO (CKJ): TBI
        return (true);
    }

    public getUser(userId: number): PersonData {
        return this.$store.getters['User/getCacheUser'](userId);
    }
}
